import React from 'react';
import BeforeAfterSlider from './BeforeAfterSlider';

function FeaturedShowcase() {
  return (
    <section className="bg-slate-50 py-8 md:py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center bg-water-100 text-water-700 font-semibold px-6 py-3 rounded-full text-lg animate-pulse">
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Drag the slider to compare before & after
            <svg className="w-6 h-6 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          <BeforeAfterSlider
            beforeImage="/pond-algae-before.jpg"
            afterImage="/pond-algae-after.jpg"
            title="Pond Algae Treatment"
          />

          <div className="mt-6 text-center">
            <h3 className="text-xl font-bold text-brand-900 mb-2">
              Pond Algae Treatment
            </h3>
            <p className="text-brand-700 mb-4">
              Complete transformation from algae-covered water to a clean, healthy pond ecosystem.
            </p>
            <a
              href="#gallery"
              className="inline-block text-water-600 hover:text-water-700 font-semibold"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#gallery')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              View more transformations →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturedShowcase;
